import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatetaxiservicepune() {



const cardData = {
  keyword: " Corporate Taxi Service Pune  ",

"headingDescription": "SRS Cab Service provides Corporate Taxi Service in Pune, offering professional, reliable, and comfortable transportation solutions for businesses and corporate employees. Whether it’s daily office commutes, airport transfers, client pickups, or corporate events, our well-maintained fleet and experienced drivers ensure timely and stress-free travel. With flexible routes, transparent pricing, and 24/7 customer support, SRS Cab Service is the trusted partner for seamless corporate travel in Pune.",
"topPlaces": [
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "A key IT hub in Pune. Corporate clients use SRS Cab Service for daily employee transport and client visits to this location."
  },
  {
    "title": "Hinjewadi Phase 1 & 2",
    "description": "Home to multiple IT companies and offices. SRS Cab Service ensures professional corporate taxi services for employees and executives commuting here."
  },
  {
    "title": "Magarpatta City",
    "description": "A prominent corporate and IT campus. Companies rely on SRS Cab Service for employee pickups, office transfers, and client transport."
  },
  {
    "title": "EON IT Park",
    "description": "SRS Cab Service provides corporate taxi solutions for office staff and visitors, ensuring punctual and comfortable commuting."
  },
  {
    "title": "Kalyani Nagar",
    "description": "A corporate and residential hub. Businesses and employees use SRS Cab Service for convenient transportation solutions from Kalyani Nagar."
  },
  {
    "title": "Viman Nagar",
    "description": "A major commercial and IT area. Corporate clients rely on SRS Cab Service for safe, timely, and efficient taxi services."
  },
  {
    "title": "Baner",
    "description": "An important IT and business zone in Pune. Companies use SRS Cab Service for daily employee commute and corporate travel needs."
  },
  {
    "title": "Pimpri Chinchwad Industrial Area",
    "description": "Industrial and corporate offices depend on SRS Cab Service for reliable corporate taxi services for staff and executives."
  },
  {
    "title": "Hadapsar",
    "description": "A growing corporate and industrial hub. Businesses use SRS Cab Service for office transfers, airport pickups, and client transport."
  },
  {
    "title": "Wakad",
    "description": "A residential and IT hub. Employees and corporate clients use SRS Cab Service for smooth and timely commuting to offices and events."
  }
],



services: [
{
name: "Corporate Cab Service Pune",
description: "Corporate cab service Pune offers reliable transportation for business and company travel needs. Organizations can book cabs for employees and executives. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with corporate cab services."
},
{
name: "Pune Corporate Taxi Service",
description: "Pune corporate taxi service provides efficient travel solutions for businesses and employees. Companies can arrange daily and outstation transport. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with corporate taxi services."
},
{
name: "Corporate Taxi Booking Pune",
description: "Corporate taxi booking Pune offers quick and easy reservation options for companies. Businesses can book taxis anytime for employees. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Corporate Cab Booking Pune",
description: "Corporate cab booking Pune provides convenient booking solutions for business travel. Companies can manage employee transportation efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with corporate cab services."
},
{
name: "Corporate Taxi Hire Pune",
description: "Corporate taxi hire Pune offers flexible rental services for companies and business travel. Businesses can book taxis for daily and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Corporate Cab Hire Pune",
description: "Corporate cab hire Pune provides dependable transport for employees and executives. Companies can book cabs for office travel and meetings. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Corporate Travel Taxi Pune",
description: "Corporate travel taxi Pune offers smooth transportation for business trips and corporate events. Companies can arrange travel for employees and clients. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with corporate travel services."
},
{
name: "Business Taxi Service Pune",
description: "Business taxi service Pune provides reliable transport for professionals and corporate teams. Companies can book taxis for meetings and daily travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with business taxi services."
},
{
name: "Executive Taxi Service Pune",
description: "Executive taxi service Pune offers premium travel for corporate clients and executives. Businesses can book high-end vehicles for comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with executive taxi services."
},
{
name: "Company Taxi Service Pune",
description: "Company taxi service Pune provides organized transport for business employees. Companies can arrange daily pickup and drop services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with company taxi services."
},
{
name: "Corporate Airport Taxi Pune",
description: "Corporate airport taxi Pune offers reliable airport transfer for business travelers. Companies can book cabs for timely pickup and drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport taxi services."
},
{
name: "Corporate Pickup and Drop Taxi Pune",
description: "Corporate pickup and drop taxi Pune provides daily commute solutions for employees. Companies can arrange fixed routes and schedules. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with pickup and drop services."
},
{
name: "Corporate Taxi Provider Pune",
description: "Corporate taxi provider Pune offers complete transport solutions for companies. Businesses can outsource employee travel services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible service plans are available. Travel easily with taxi provider services."
},
{
name: "Corporate Car Rental Pune",
description: "Corporate car rental Pune offers flexible vehicle options for business travel. Companies can book cars for short and long-term use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental services."
},
{
name: "Corporate Taxi Service Near Me Pune",
description: "Corporate taxi service near me Pune helps businesses find nearby transport solutions quickly. Companies can book taxis instantly for employees. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Corporate Taxi Service Pune for Companies",
description: "Corporate taxi service Pune for companies provides customized transport for business clients. Organizations can manage employee travel efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible plans are available. Travel easily with corporate taxi services."
},
{
name: "Office Corporate Taxi Pune",
description: "Office corporate taxi Pune offers convenient transport for employees and executives. Companies can arrange daily office commute services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with office taxi services."
},
{
name: "Corporate Taxi Transport Pune",
description: "Corporate taxi transport Pune provides reliable travel for business operations and staff. Companies can arrange daily and event transport. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi transport services."
},
{
name: "Corporate Taxi Booking Service Pune",
description: "Corporate taxi booking service Pune offers easy reservation solutions for businesses. Companies can manage transport efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with booking services."
},
{
name: "Innova Corporate Taxi Pune",
description: "Innova corporate taxi Pune offers spacious SUV travel for company employees and teams. Businesses can book vehicles for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova services."
},
{
name: "Innova Crysta Corporate Taxi Pune",
description: "Innova Crysta corporate taxi Pune provides premium SUV travel for executives and business clients. Companies can ensure comfortable journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Ideal for corporate use. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Corporate Taxi Pune",
description: "Ertiga corporate taxi Pune offers comfortable 7 seater travel for company staff. Businesses can book vehicles for daily commute. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Corporate Taxi Pune",
description: "Dzire corporate taxi Pune provides affordable sedan travel for business employees. Companies can book vehicles for daily travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Corporate Taxi Pune",
description: "Sedan corporate taxi Pune offers budget-friendly travel for corporate staff. Companies can book vehicles for daily and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan transport services."
},
{
name: "SUV Corporate Taxi Pune",
description: "SUV corporate taxi Pune provides spacious travel for business teams and executives. Companies can book vehicles for group and long-distance travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with SUV taxi services."
}
],

tableData: [
["Corporate Cab Service Pune","Pune Corporate Taxi Service"],
["Corporate Taxi Booking Pune","Corporate Cab Booking Pune"],
["Corporate Taxi Hire Pune","Corporate Cab Hire Pune"],
["Corporate Travel Taxi Pune","Business Taxi Service Pune"],
["Executive Taxi Service Pune","Company Taxi Service Pune"],
["Corporate Airport Taxi Pune","Corporate Pickup and Drop Taxi Pune"],
["Corporate Taxi Provider Pune","Corporate Car Rental Pune"],
["Corporate Taxi Service Near Me Pune","Corporate Taxi Service Pune for Companies"],
["Office Corporate Taxi Pune","Corporate Taxi Transport Pune"],
["Corporate Taxi Booking Service Pune","Innova Corporate Taxi Pune"],
["Innova Crysta Corporate Taxi Pune","Ertiga Corporate Taxi Pune"],
["Dzire Corporate Taxi Pune","Sedan Corporate Taxi Pune"],
["SUV Corporate Taxi Pune","Corporate Cab Service Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Premium Corporate Taxi Service in Pune",
    WhyChoosedescription: "SRS Cab Service offers premium corporate taxi service in Pune for business travel, client meetings, airport transfers, and executive rides with professional drivers and high service standards."
  },
  {
    WhyChooseheading: "Customized Corporate Travel Solutions",
    WhyChoosedescription: "We provide tailored corporate taxi services including dedicated vehicles, hourly rentals, and employee transport plans designed as per company requirements."
  },
  {
    WhyChooseheading: "24/7 Corporate Taxi Availability",
    WhyChoosedescription: "Our corporate taxi service is available 24/7 to support business travel, late-night meetings, airport pickups, and flexible work schedules."
  },
  {
    WhyChooseheading: "Wide Range of Executive Vehicles",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, luxury vehicles, Tempo Travellers, and buses for corporate travel needs."
  },
  {
    WhyChooseheading: "Professional Drivers & Business Etiquette",
    WhyChoosedescription: "Our drivers are trained, background-verified, and follow professional behavior standards to ensure a comfortable and corporate-friendly travel experience."
  },
  {
    WhyChooseheading: "GPS Tracking & Safety Assurance",
    WhyChoosedescription: "All corporate taxis are equipped with GPS tracking for real-time monitoring, ensuring safety, transparency, and efficient route management."
  },
  {
    WhyChooseheading: "On-Time Pickup & Reliable Service",
    WhyChoosedescription: "We ensure punctual pickups and drops, helping professionals reach meetings, offices, and airports on time without delays."
  },
  {
    WhyChooseheading: "Trusted Corporate Taxi Partner in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by corporates and IT companies for reliable, affordable, and high-quality corporate taxi services in Pune."
  }
]
}

const faqData = [
  { 
    question: "Do you provide corporate taxi service in Pune?", 
    answer: "Yes, SRS Cab Service offers professional corporate taxi service in Pune for business travel, employee transport, and executive rides with reliable and safe service." 
  },
  { 
    question: "Can corporate taxi services be customized?", 
    answer: "Yes, we provide customized corporate travel solutions including dedicated cabs, route planning, hourly rentals, and employee transportation plans based on company needs." 
  },
  { 
    question: "Is corporate taxi service available 24/7?", 
    answer: "Yes, our corporate taxi service operates 24/7 to support business travel, night shifts, airport transfers, and urgent bookings." 
  },
  { 
    question: "Which vehicles are available for corporate travel?", 
    answer: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, luxury vehicles, Tempo Travellers, and buses depending on travel requirements." 
  },
  { 
    question: "Do you provide airport taxi service for corporates?", 
    answer: "Yes, we provide airport pickup and drop services for corporate clients with punctual service and professional drivers." 
  },
  { 
    question: "Are drivers professional and verified?", 
    answer: "Yes, all drivers are background-verified, trained, and experienced to provide professional and safe corporate travel experience." 
  },
  { 
    question: "Do you provide service in IT hubs like Hinjewadi and Kharadi?", 
    answer: "Yes, we provide corporate taxi services across major IT hubs like Hinjewadi, Baner, Wakad, Kharadi, and Viman Nagar." 
  },
  { 
    question: "Is service available for both small and large teams?", 
    answer: "Yes, we provide flexible taxi services for individual executives as well as large corporate teams." 
  },
  { 
    question: "Are corporate taxi services affordable?", 
    answer: "Yes, we offer cost-effective corporate taxi solutions with transparent pricing and customized plans for businesses." 
  },
  { 
    question: "How can I book corporate taxi service in Pune?", 
    answer: "You can easily book corporate taxi service by contacting us directly. We offer quick onboarding and smooth service setup for companies." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Admin Manager - IT Company",
    feedback:
      "We have been using SRS Cab Service for corporate travel in Pune and the experience has been excellent. Drivers are professional, vehicles are clean, and service is always on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Business Executive",
    feedback:
      "Best corporate taxi service in Pune. I regularly use their service for meetings and airport travel. Always punctual, comfortable rides, and very professional service.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Corporate Taxi Service Pune",
  "description": "Reliable corporate taxi service in Pune with SRS Cab. Book corporate cabs for business travel, office pickup and drop, airport transfers, and executive travel. 24/7 service with Innova, Innova Crysta, Ertiga, Dzire, sedan, and SUV cabs.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/corporate-taxi-service-pune",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune, Maharashtra"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Corporate Taxi Service in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable corporate taxi service in Pune with SRS Cab. Business travel, office pickup/drop, airport transfers, and executive travel available 24/7. Innova, Ertiga, Dzire, sedan, and SUV cabs." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/104.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatetaxiservicepune;